import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header3 from "../../components/header/Header3";
import Footer2 from "../../components/footer2";
import Category10 from "../../components/category/Category10";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import { useParams } from "react-router-dom";
import Breadcrumbuser from "../../components/breadcrumbuser";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

CourseScreen.propTypes = {};

function CourseScreen(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

 const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { logout } = useContext(AuthContext);
  
const [isSubmitting, setIsSubmitting] = useState(false);
   const [openTabs, setOpenTabs] = useState({
    tab1: true,
    tab2: true,
    tab3: true,
  });

  const toggleTab = (tab) => {
    setOpenTabs((prev) => ({
      ...prev,
      [tab]: !prev[tab],
    }));
  };


  const cardStyle = {
    flex: '1 1 100%',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '2px 2px 6px rgba(0,0,0,0.1)',
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: '#003300',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '8px 8px 0 0',
    fontSize: '14px',
    color: "white",
  };

  const contentStyle = {
    padding: '16px',
    backgroundColor: '#fff',
    borderTop: '1px solid #ccc',
    fontSize: '14px',
  };

const { clientId } = useParams();
  const [category, setCategory] = useState({ Title: "", Qdesc: "", Lname: "", Ename: "", Path1: "" });

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-course-details/${clientId}`);
        setCategory(response.data);
      } catch (error) {
        console.error("Error fetching category details:", error);
      }
    };

    fetchCategoryDetails();
  }, [clientId]);

  const [clients, setClients] = useState([]);
  useEffect(() => {
    if (!clientId) return; // Ensure clientId is available

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/curriculumsort/${clientId}`)
      .then((response) => {
        setClients(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);

  
  const [modalVideo, setModalVideo] = useState(null); // store selected video

const [language, setLanguage] = useState("en");

  const [clientsnew, setClientsnew] = useState([]);
  useEffect(() => {
    if (!clientId) return;

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/videosort/${clientId}`)
      .then((response) => setClientsnew(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);




  const [currentIndex, setCurrentIndex] = useState(null); // index of selected video

const openVideoModal = (videoSrc, index) => {
  setModalVideo(videoSrc);
  setCurrentIndex(index);
  setShowQuestions(false);
   // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
};

  const closeModal = () => {
    setModalVideo(null);
    setShowQuestions(false);
  };

  const handlePrev = () => {
  if (currentIndex > 0) {
    const newIndex = currentIndex - 1;
    setModalVideo(clientsnew[newIndex].Path1);
    setCurrentIndex(newIndex);
     setShowQuestions(false);
      // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
  }
};

const handleNext = () => {
  if (currentIndex < clientsnew.length - 1) {
    const newIndex = currentIndex + 1;
    setModalVideo(clientsnew[newIndex].Path1);
    setCurrentIndex(newIndex);
     setShowQuestions(false);
      // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
  }
};

const openQuestionsModal = (videoId) => {
  const filteredQuestions = clientslatestnew.filter(
    (q) => String(q.Videoid) === String(videoId)
  );

  setQuestionsForCurrentVideo(filteredQuestions);
  setShowQuestions(true);

  // No video
  setModalVideo(null);
  setCurrentIndex(null);

  // Reset quiz state
  setSelectedAnswers({});
  setSubmitted(false);
};
  
 const [clientslatest, setClientslatest] = useState([]);
  useEffect(() => {
    if (!clientId) return; // Ensure clientId is available

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/studymaterialsort/${clientId}`)
      .then((response) => {
        setClientslatest(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);

  // Following function calls questions related to Videos
 const [clientslatestnew, setClientslatestnew] = useState([]);
  useEffect(() => {
    if (!clientId) return; // Ensure clientId is available

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/questionssort/${clientId}`)
      .then((response) => {
        setClientslatestnew(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);


const [questionsForCurrentVideo, setQuestionsForCurrentVideo] = useState([]);
const [showQuestions, setShowQuestions] = useState(false);

const handleVideoEnd = () => {
  const currentVideo = clientsnew[currentIndex];
  if (!currentVideo) return;

  console.log("currentVideo.Id:", currentVideo.Id);
  console.log("Available question Videoids:", clientslatestnew.map(q => q.Videoid));

  const filteredQuestions = clientslatestnew.filter(
    (q) => String(q.Videoid) === String(currentVideo.Id)
  );

  console.log("Filtered questions:", filteredQuestions);

  setQuestionsForCurrentVideo(filteredQuestions);
  setShowQuestions(true);

   // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
    
};

const [selectedAnswers, setSelectedAnswers] = useState({});
const [submitted, setSubmitted] = useState(false);

const handleAnswerSelect = (questionId, option) => {
  setSelectedAnswers(prev => ({ ...prev, [questionId]: option }));
};

const handleSubmitAnswers = () => {
  setSubmitted(true);
};

const [expandedIndex, setExpandedIndex] = useState(null);


const toggleReadMore = (index) => {
  setExpandedIndex((prevIndex) =>
    prevIndex === index ? null : index
  );
};



  const MAX_LENGTH = 150; // characters to show initially


const [userData, setUserData] = useState({
  fullName: "",
  email: "",
  contactNo: ""
});

useEffect(() => {
  const fetchUserData = async () => {
    try {
      const storedUserId = localStorage.getItem("userId");
      if (!storedUserId) return;

      const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${storedUserId}`);
      if (response.data) {
        setUserData({
          fullName: response.data.Named || "",
          email: response.data.Email || "",
          contactNo: response.data.Cno || ""
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  fetchUserData();
}, []);



const [formData, setFormData] = useState({
  subject: "",
  department: "",
  message: ""
});

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
   
    if (!formData.subject) newErrors.subject = "Subject is required";
    if (!formData.department) newErrors.department = "Please select a department";
    if (!formData.message) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "contact") {
      // Allow only digits and limit to 10 characters
      const numericValue = value.replace(/\D/g, ""); // remove non-digits
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  const dataToSend = {
    ...formData,
    Cname: category.Title,
    Cid: category.Id,
    fullName: userData.fullName,
    email: userData.email,
    contactNo: userData.contactNo,
    timestamp: new Date().toISOString(), // ISO format (e.g., 2025-07-07T07:45:00.000Z)
    Mstatus: "0"
  };
setIsSubmitting(true); // Disable button
  try {
    await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/submithelpform", dataToSend);
       toast.success("We have received your message! We'll contact you within 24 hrs.");
    setFormData({
      subject: "",
      department: "",
      message: ""
    });
  } catch (err) {
   toast.error("Sorry! Some error occurred. Please try again later.");
  } finally {
    setIsSubmitting(false); // Re-enable button
  }
};

const [rating, setRating] = useState(0);
const [hover, setHover] = useState(0);
const [review, setReview] = useState("");
const [reviewSubmitting, setReviewSubmitting] = useState(false);
const [existingReview, setExistingReview] = useState(null);
const [alreadyReviewed, setAlreadyReviewed] = useState(false);
const [reviewChecked, setReviewChecked] = useState(false);

useEffect(() => {
  const fetchUserReview = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId || !category.Id) return;

      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-user-review",
        {
          params: {
            CustomerId: userId,
            CourseId: category.Id
          }
        }
      );

      if (response.data.exists) {
        setExistingReview(response.data.review);
        setAlreadyReviewed(true);
      }

    } catch (error) {
      console.error("Error fetching review:", error);
    } finally {
      setReviewChecked(true); // ✅ IMPORTANT
    }
  };

  fetchUserReview();
}, [category.Id]);

const handleReviewSubmit = async (e) => {
  e.preventDefault();

  if (alreadyReviewed) {
  toast.error("You have already submitted a review for this course.");
  return;
}

  if (!rating) {
    toast.error("Please select a rating");
    return;
  }

  if (!review.trim()) {
    toast.error("Please enter your feedback");
    return;
  }

  try {
    setReviewSubmitting(true);

    const userId = localStorage.getItem("userId");

    await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/submit-review", {
      CustomerId: userId,
      CourseId: category.Id,
      Rating: rating,
      Feedback: review,
      Status: "pending",
      CreatedAt: new Date().toISOString()
    });

    toast.success("Thank you! Your review has been submitted.");

// ✅ instantly update UI (NO reload needed)
setAlreadyReviewed(true);

setExistingReview({
  Rating: rating,
  Feedback: review,
  Status: "pending"
});

// optional reset
setRating(0);
setReview("");

  } catch (error) {
    toast.error("Something went wrong. Please try again.");
  } finally {
    setReviewSubmitting(false);
  }
};

  return (
    <>
    <Helmet>
            <title>{category.Title} - Course Panel | Sauntesthyam LLP</title>
          </Helmet>

          <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/userdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
          </div>
         

           <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
           <div >
                      <button onClick={logout} className="header-customize-item button" style={{padding: "12px 20px",
    background:"none",
    backgroundColor:"white",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "black",
    borderColor: "red",
    textTransform: "capitalize"}}>Logout</button>
                    </div>
        </div>
      </div>
  
     
      
      <Header3 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbuser title="Course Panel" />

          <section style={{ paddingTop: "20px", marginBottom:"25px" }}>
              <div className="tf-container">
                <div className="row"  style={{maxWidth:"1200px", margin:"auto", padding:"auto"}}>
                 

                  <div className="col-lg-4 wow fadeInUp">
                      <div style={{textAlign:"center"}}>
                         <img
          src={category.Path1} // Display image from Path1
          alt={category.Title}
          style={{ width: "100%", height: "auto", borderRadius: "10px", border:"solid #f2f2f2 3px", margin:"auto", marginBottom:"10px" }}
        />
                      </div>
                    </div>
                     <div className="col-lg-8 wow fadeInUp">
                      <div>
                        <div className="tf-title style-2 style-4" style={{marginBottom:"20px", textAlign:"left"}}>
                      <div className="group-title">
                        <h1 style={{ fontSize: "17px", marginBottom: "0px", marginTop:"0px", color:"#14a077", maxWidth:"unset" }}>{category.Title}</h1>
                      </div>
                       <table style={{
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "0px",
  fontFamily: "Arial, sans-serif",
  fontSize: "15px",
  color: "#333"
}}>
  <tbody>
   
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Language</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Lname}</td>
    </tr>
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Study Material</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Smat}</td>
    </tr>
     <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Doubt Clearing Session(s)</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.a11}</td>
    </tr>
    <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Questionnaire</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.a22}</td>
    </tr>

     <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Course Validity</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Validity} Days</td>
    </tr>
   
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9",
        width: "30%"
      }}>Educator</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Ename}</td>
    </tr>
   
  </tbody>
</table>
                    </div>
                      </div>
                    </div>

                     <div className="col-lg-6 wow fadeInUp">
                      <div className="box-latest">
            <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab2')} style={headerStyle}>
            <span>Video Lectures</span>
            <span>{openTabs.tab2 ? '−' : '+'}</span>
          </button>
          {openTabs.tab2 && (
            <div style={contentStyle}>
             <style>{`
    .rich-content img {
      display: block;
      margin: 10px auto;
      max-width: 100%;
      height: auto;
      float: none !important;
      width: 100% !important;
    }

    .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
  `}</style>

<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "15px",
  }}
>
  <span>English</span>

  <label className="switch">
    <input
      type="checkbox"
      checked={language === "hi"}
      onChange={(e) => setLanguage(e.target.checked ? "hi" : "en")}
    />
    <span className="slider"></span>
  </label>

  <span>हिन्दी</span>
</div>

                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
        
        <tbody>
          {clientsnew.map((client, index) => (
            <tr key={index} >
            <td style={{verticalAlign:"top", textAlign:"center", width:"30%"}}>
               <img
                          src={client.Path2 || "default-image.jpg"} // Use Path1 for image
                          alt={client.Title}
                          style={{ width: "100%", height: "auto", borderRadius: "5px" }}
                        />

                         
            </td>
              <td  style={{verticalAlign:"top", width:"70%"}}>
                  <p style={{marginBottom:"5px", paddingLeft:"10px"}}><strong>
  {language === "hi" ? client.Title2 : client.Title}
</strong></p>
                <p style={{ whiteSpace: "pre-wrap", paddingLeft: "10px" }}>
  {language === "hi"
    ? (expandedIndex === index
        ? client.Qdesc2
        : `${client.Qdesc2.slice(0, MAX_LENGTH)}... `)
    : (expandedIndex === index
        ? client.Qdesc
        : `${client.Qdesc.slice(0, MAX_LENGTH)}... `)}

  <span
    onClick={() => toggleReadMore(index)}
    style={{
      color: "green",
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    {language === "hi"
      ? (expandedIndex === index ? "कम पढ़ें" : "और पढ़ें")
      : (expandedIndex === index ? "Read less" : "Read more")}
  </span>
</p>
               <div style={{ float: "right", marginTop: "12px", marginBottom:"15px" }}>
  {/* Play Video */}
  <p
    onClick={() => openVideoModal(client.Path1, index)}
    style={{
      display: "inline-block",
      marginRight: "10px",
      color: "#14a077",
      fontWeight: "bold",
      padding: "5px 10px",
      backgroundColor: "#f0fff0",
      borderRadius: "3px",
      cursor: "pointer"
    }}
  >
   {language === "hi" ? "▶ अभी देखें" : "▶ Play Now"}
  </p>

  {/* Questions Only */}
  <p
    onClick={() => openQuestionsModal(client.Id)}
    style={{
      display: "inline-block",
      color: "#003300",
      fontWeight: "bold",
      padding: "5px 10px",
      backgroundColor: "#e6fff2",
      borderRadius: "3px",
      cursor: "pointer"
    }}
  >
   {language === "hi" ? "📝 क्विज़ शुरू करें" : "📝 Start Quiz"}
  </p>
</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      

      {/* Video Modal */}
    {(modalVideo || showQuestions) && (
  <div style={modalOverlay} onClick={closeModal}>
    <div
      style={modalContent}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <div style={closeWrapper}>
        <span style={closeBtn} onClick={closeModal}>&times;</span>
      </div>

      {/* Left Arrow (video only) */}
      {modalVideo && currentIndex > 0 && (
        <span
          onClick={handlePrev}
          style={{
            position: "absolute",
            left: "-40px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "2rem",
            color: "white",
            backgroundColor: "rgba(0,0,0,0.6)",
            borderRadius: "50%",
            width: "35px",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            zIndex: 10001
          }}
        >
          &#8592;
        </span>
      )}

      {/* Right Arrow (video only) */}
      {modalVideo && currentIndex < clientsnew.length - 1 && (
        <span
          onClick={handleNext}
          style={{
            position: "absolute",
            right: "-40px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "2rem",
            color: "white",
            backgroundColor: "rgba(0,0,0,0.6)",
            borderRadius: "50%",
            width: "35px",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            zIndex: 10001
          }}
        >
          &#8594;
        </span>
      )}

      {/* Video (only if exists) */}
      {modalVideo && (
        <video
          src={modalVideo}
          controls
          controlsList="nodownload"
          style={{ width: "100%", borderRadius: "8px" }}
          autoPlay
          onContextMenu={(e) => e.preventDefault()}
          onEnded={handleVideoEnd}
        />
      )}

      {/* Questions */}
      {showQuestions && questionsForCurrentVideo.length > 0 && (
        <div
          className="question-container"
          style={{ padding: "10px", maxHeight: "300px", overflowY: "scroll" }}
        >
          <p
            style={{
              marginBottom: "15px",
              backgroundColor: "#f0fff0",
              padding: "5px",
              border: "solid #f2f2f2 thin"
            }}
          >
            <b>Test Your Learning - Quiz</b><br />
            Following quick Q&A session will help you determine your current learning curve and revision of core course concepts.
          </p>

          {questionsForCurrentVideo.map((q, index) => (
            <div
              key={q.Id}
              style={{
                marginBottom: "16px",
                borderBottom: "1px solid #ccc",
                paddingBottom: "10px"
              }}
            >
              <p><strong>{index + 1}. {q.Title}</strong></p>
              <p>{q.Qdesc}</p>

              <table style={{ width: "100%" }}>
                {['A', 'B', 'C', 'D'].map((opt) => {
                  const optionText = q[`Option${opt.toLowerCase()}`];
                  const isSelected = selectedAnswers[q.Id] === opt;
                  const isCorrect = q.Result === opt;

                  return (
                    <tr key={opt}>
                      <td
                        onClick={() => handleAnswerSelect(q.Id, opt)}
                        style={{
                          padding: "0px 10px",
                          cursor: "pointer",
                          backgroundColor: submitted
                            ? isSelected
                              ? isCorrect
                                ? "#d4edda"
                                : "#f8d7da"
                              : isCorrect
                              ? "#d4edda"
                              : "transparent"
                            : isSelected
                            ? "#cce5ff"
                            : "transparent",
                          borderRadius: "4px"
                        }}
                      >
                        {opt}. {optionText}
                      </td>
                    </tr>
                  );
                })}
              </table>

              {submitted && (
                <p style={{ marginTop: "5px" }}>
                  Your answer: <strong>{selectedAnswers[q.Id] || "Not answered"}</strong> | Correct: <strong>{q.Result}</strong>
                </p>
              )}
            </div>
          ))}

          {!submitted && (
            <button
              onClick={handleSubmitAnswers}
              style={{
                marginTop: "0px",
                padding: "10px 15px",
                cursor: "pointer",
                float: "right",
                backgroundColor: "#003300",
                color: "white",
                border: "none",
                borderRadius: "3px"
              }}
            >
              Submit Your Answers
            </button>
          )}
        </div>
      )}
    </div>
  </div>
)}
            </div>
          )}
        </div>
                      </div>
                    </div>
                 
                    <div className="col-lg-6 wow fadeInUp">
                      <div className="box-latest"  style={{marginBottom:"20px"}}>
           <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab1')} style={headerStyle}>
            <span>Study Material</span>
            <span>{openTabs.tab1 ? '−' : '+'}</span>
          </button>
          {openTabs.tab1 && (
            <div style={contentStyle}>
             <table className="table bordered-table sm-table mb-0" style={{width:"100%"}}>
                        
                                    <tbody>
  {clientslatest.map(client => (
    <tr key={client.Id} style={{ borderBottom: "none", backgroundColor: "#f9f9f9", transition: "0.3s" }}>
      <td style={{ padding: "10px 5px", fontSize: "0.9rem", color: "#333", backgroundColor: "white" }}><b>{client.Title}</b><br/>{client.Qdesc}<br/> <a
    href={client.Path1}
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-info btn-small"
    style={{
      fontSize: "1rem",
      borderRadius: "5px",
      marginRight: "0px",
      textDecoration: "none",
      color: "white",
      padding:"5px 10px", backgroundColor:"#f0fff0", borderRadius:"3px", 
      border: "none", color:"#14a077", fontWeight:"bold",
      cursor: "pointer", float:"right", marginTop:"10px"
    }}
  ><img
                  src="https://img.icons8.com/ios-filled/50/document.png"
                  alt="Open PDF"
                  style={{ width: "16px", cursor: "pointer" }}
                  
                /> Open
  </a></td>
    </tr>
  ))}
</tbody>
</table>
            </div>
          )}
        </div>
</div>
         <div className="box-latest">

        <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab3')} style={headerStyle}>
            <span>Course Curriculum</span>
            <span>{openTabs.tab3 ? '−' : '+'}</span>
          </button>
          {openTabs.tab3 && (
            <div style={contentStyle}>
             <table className="table bordered-table sm-table mb-0" style={{width:"100%"}}>
                        
                                    <tbody>
  {clients.map(client => (
    <tr key={client.Id} style={{ borderBottom: "none", backgroundColor: "#f9f9f9", transition: "0.3s" }}>
      <td style={{ padding: "10px", fontSize: "0.9rem", color: "#333", backgroundColor: "white" }}><b>{client.Title}</b><br/>{client.Qdesc}</td>
    </tr>
  ))}
</tbody>
</table>
            </div>
          )}
        </div>
                      </div>


 <div className="box-latest" style={{marginTop:"20px"}}>
<div className="form-candidate" style={{padding:"20px 0px", border:"none", paddingBottom:"0px"}}>
                  <h6 style={{fontWeight: "700",
    fontSize: "17px",
    lineHeight: "20px"}}>Support is just a click away!</h6>
                    <p style={{marginBottom:"20px", marginTop:"6px",    fontWeight: "400",
    fontSize: "15px",
    lineHeight: "28px"
}}>Use the following form to connect with our support executives. We assure to get back to you with a resolution within one Business Day.<br/><b>Please Note</b>: Use the following form or call us on +91-8960708245 to request your course completion certificate.</p>
                 <form onSubmit={handleSubmit}>
      <div className="group-input">
      <div className="ip">
        <select name="department" value={formData.department} onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}>
          <option value="">-- Select Department --</option>
          <option value="General Support">Course Certification</option>
          <option value="Account Support">Technical Support</option>
          <option value="Billing Support">Billing Support</option>
          <option value="Astrologer Support">General Support</option>
          <option value="Other">Other</option>
        </select>
        {errors.department && <small>{errors.department}</small>}
      </div>
        <div className="ip">
          <input
            type="text"
            name="subject"
            placeholder="Subject Of Concern"
            value={formData.subject}
            onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
          />
          {errors.subject && <small>{errors.subject}</small>}
        </div>
      </div>

     

      

      <div className="ip out">
        <textarea
          name="message"
          placeholder="Describe your issue..."
          value={formData.message}
          onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
        />
        {errors.message && <small>{errors.message}</small>}
      </div>

     <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Send Message"}
</button>
    </form>
    <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
                  </div>

</div>



<div className="box-latest" style={{ marginTop: "20px" }}>
  <div className="form-candidate" style={{ padding: "20px 0px", border: "none" }}>

    <h6 style={{ fontWeight: "700", fontSize: "17px" }}>
      Share Your Experience
    </h6>

    <p style={{ marginBottom: "15px", fontSize: "14px" }}>
      Your feedback helps us improve and guide other learners.
    </p>

{!reviewChecked ? (
  <p>Loading your review...</p>
) : alreadyReviewed ? (

  // ✅ SHOW EXISTING REVIEW ONLY
  <div  style={{
      marginTop: 25,
      padding: "20px",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      backgroundColor: "#fafafa"
    }}>

    <p><b>Your Rating:</b></p>

    <div>
      {[1,2,3,4,5].map((star) => (
        <span
          key={star}
          style={{
            fontSize: "24px",
            color: existingReview?.Rating >= star ? "#FFD700" : "#ccc"
          }}
        >
          ★
        </span>
      ))}
    </div>

    <p style={{ marginTop: "10px" }}>
      <b>Your Feedback:</b><br />
      {existingReview?.Feedback}
    </p>

    {/* <p style={{ fontSize: "13px", color: "#777" }}>
      Status: {existingReview?.Status === "pending" ? "Under Review" : "Approved"}
    </p> */}

  </div>
    ) : (

      /* 🆕 SHOW FORM ONLY IF NOT REVIEWED */
      <form onSubmit={handleReviewSubmit}>

        {/* ⭐ Rating */}
        <div style={{ marginBottom: "15px" }}>
          {[1,2,3,4,5].map((star) => (
            <span
              key={star}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
              style={{
                fontSize: "28px",
                cursor: "pointer",
                color: (hover || rating) >= star ? "#FFD700" : "#ccc",
                marginRight: "5px"
              }}
            >
              ★
            </span>
          ))}
        </div>

        {/* Feedback */}
        <div className="ip out">
          <textarea
            placeholder="Write your feedback..."
            value={review}
            onChange={(e) => setReview(e.target.value)}
            style={{ background: "#f5f5f5", color: "black" }}
          />
        </div>

        <button type="submit" disabled={reviewSubmitting}>
          {reviewSubmitting ? "Submitting..." : "Submit Review"}
        </button>

      </form>
    )}

  </div>
</div>






                    </div>

                    
                
                </div>
              </div>
            </section>
     
      
      
      <div
                className="floating-buttons"
                style={{
                  position: "fixed",
                  bottom: "20px",
                  left: "20px",
                  zIndex: "1000",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {/* Call Button */}
                <a
                  href={`tel:+918960708425`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#007BFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaPhoneAlt />
                </a>
              
                {/* WhatsApp Button */}
                <a
                  href={`https://wa.me/918960708425`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#25D366",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaWhatsapp />
                </a>
              </div>
      <Footer2 />
      <Gotop />
    </>
  );
}

// Modal styles
const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalContent = {
  position: "relative",
  background: "white",
  padding: "0.5rem",
  borderRadius: "3px",
  width: "80%",
  maxWidth: "600px",
  boxShadow: "0 0 20px rgba(0,0,0,0.5)",
  paddingBottom:"0.1rem",
};

const closeWrapper = {
  position: "absolute",
  top: "-25px",
  right: "-25px",
  zIndex: 10000,
  background: "black",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  cursor: "pointer",
};

const closeBtn = {
  fontSize: "2rem",
  color: "white",
  lineHeight: "1",
  marginTop:"-10px",
};

export default CourseScreen;
